import { gql } from '@apollo/client'
import { reviewSummaryFragment } from 'modules/reviews/fragments.graphql'

export const getBrandReviewSummary = gql`
  ${reviewSummaryFragment}
  query GetBrandReviewSummary($slug: String, $id: ID) {
    brand(slug: $slug, id: $id) {
      id
      slug
      title
      rip
      description
      primaryImageFullPath
      myReview {
        id
      }
      reviewSummary {
        ...ReviewSummaryFields
      }
    }
  }
`
